import { Coordinate } from 'src/app/models/coordinate/coordinate';
import { SearchArea } from 'src/app/models/search-area/search-area';
import { Time } from 'src/app/models/time/time';
import { SearchAreaGroup } from '../../../models/search-area-group/search-area-group';
import { Params as SearchParamsParams, SearchParams } from './search-params';
import { CurrentPositionState } from './search.reducer';
import { ViewMode } from './view-mode';

interface Params {
  seats: number;
  startsFromTime: string;
  searchArea: SearchArea | null;
  searchAreaGroup: SearchAreaGroup | null;
  currentPositionState: CurrentPositionState;
  currentPosition: Coordinate | null;
  centerPosition: Coordinate;
}

export function makeSearchParams(params: Params): SearchParams {
  const searchParams: SearchParamsParams = {};

  searchParams.seats = params.seats;
  searchParams.startsFromTime = Time.fromISO(params.startsFromTime);

  if (params.searchAreaGroup !== null) {
    searchParams.searchAreaGroup = params.searchAreaGroup;
  }

  if (params.searchArea !== null) {
    searchParams.searchArea = params.searchArea;
    searchParams.viewMode = ViewMode.List;

    // 現在位置が有効な場合は現在位置の座標を、無効な場合は地図の中心座標をパラメーターに追加する。
    if (
      (params.currentPositionState === 'available' ||
        params.currentPositionState === 'outOfArea') &&
      params.currentPosition !== null
    ) {
      searchParams.coordinate = params.currentPosition;
    } else {
      searchParams.coordinate = params.centerPosition;
    }
  } else {
    if (params.currentPosition !== null) {
      searchParams.coordinate = params.currentPosition;
      searchParams.viewMode = ViewMode.Map;
    }
  }

  return new SearchParams(searchParams);
}
